import React from 'react'
import './CrossClientAccessRequired.scss'
import crossClientLogo from '../../../assets/images/cross-client-logo.png'

export const CrossClientAccessRequired: React.FC = () => {
  return (
    <div className='d-flex flex-column align-items-center text-center zocks-gap-4 mt-2'>
      <div className='d-flex flex-column zocks-gap-2 align-items-center'>
        <img src={crossClientLogo} alt='' className='cross-client-logo' />
        <div className='d-flex flex-column zocks-gap-0.75 align-items-center'>
          <h2>Access required</h2>
          <div className='paragraph-large cross-client-access-required-text-container'>
            Your account owner or admins need to grant you access to Client Queries.
          </div>
        </div>
      </div>
      <div className='cross-client-access-required-video-container'>
        <video
          src='https://static.zocks.io/assets/ccq/ccq_teaser.mp4'
          className='w-100 zocks-border-0.5'
          controls
          muted
          autoPlay
          playsInline
          preload='metadata'
        />
      </div>
    </div>
  )
}
